import {isFunction} from 'lodash';
import React, {Fragment, ReactNode, useCallback, useState} from 'react';
import {useTranslation} from 'react-i18next';

import {ConfirmModal, Icon, IconProps} from 'components';
import {TRANSLATION_KEYS} from 'locale';

const T_KEYS = TRANSLATION_KEYS.COMPONENTS.CONFIRM_BUTTON;

type Props = {
    modal?: {
        title?: string;
        description?: string;
    };
    iconProps?: IconProps;
    onConfirm: () => void;
    children?:
        | ReactNode
        | ((props: {onClick: (e?: React.MouseEvent) => void}) => ReactNode);
    disabled?: boolean;
};

export const ConfirmButton: React.FC<Props> = ({
    onConfirm,
    modal,
    iconProps,
    children,
    disabled
}) => {
    const {t} = useTranslation();
    const [modalOpen, setModalOpen] = useState(false);

    const handleModalClose = useCallback(
        (confirmed: boolean) => {
            if (confirmed) {
                onConfirm();
            }
            setModalOpen(false);
        },
        [onConfirm],
    );

    const handleClick = useCallback((e?: React.MouseEvent) => {
        e?.stopPropagation?.();
        setModalOpen(true);
    }, []);

    return (
        <Fragment>
            {isFunction(children) && children({onClick: handleClick})}
            {iconProps && !isFunction(children) && (
                <Icon {...iconProps} disabled={disabled} onClick={handleClick} />
            )}
            <ConfirmModal
                title={modal?.title || t(T_KEYS.TITLE)}
                okDisabled={disabled}
                open={modalOpen}
                maxWidth='xs'
                onClose={handleModalClose}
            >
                {modal?.description || t(T_KEYS.DESCRIPTION)}
            </ConfirmModal>
        </Fragment>
    );
};